// define a mixin object

export const toothMixins = {
    props: ['value', 'readonly', 'height', 'width', 'noSegments', 'redBorder'],
    data() {
        return {
            blocks: {
                first: false,
                second: false,
                secondLeft: false,
                secondRight: false,
                third: false,
                thirdLeft: false,
                thirdRight: false,

                fourth: false,
                fourthLeft: false,
                fourthRight: false,
                fifth: false,
                six: false,
                center: false,
                root: false,
                channel: false,
                periodontitis: false,
            }
        }
    },
    computed: {
        currentHeight() {
            return this.height ? this.height : '';
        },
        currentWidth() {
            return this.width ? this.width : '';
        }
    },
    watch: {
        blocks: {
            handler(newValue) {
                this.$emit('input', newValue);
                this.$emit('change', newValue);
            },
            deep: true,
        },
        value(newValue) {
            // this.blocks = newValue;
            Object.assign(this.blocks, newValue);
        }

    },
    mounted() {
        if (this.value) {
            // this.blocks = this.value;
            Object.assign(this.blocks, this.value);

        }
    },
    methods: {
        select(part) {
            if (this.readonly) return false;
            this.blocks[part] = !this.blocks[part]
        }
    }
}
